// extracted by mini-css-extract-plugin
export default {"container":"div_FAU2w","value":"div_val_30GaE","separator":"div_sep_3WXkd","crazy-slider":"div_cra_29aim"};